import { useEffect } from 'react';
import { useRegisterSW } from 'virtual:pwa-register/react';

/** How often a page left open (e.g. a live tournament page) checks for a new version. */
const UPDATE_CHECK_INTERVAL_MS = 5 * 60 * 1000;

/**
 * For read-only public pages (live tournament page, camp terms): applies a new version as soon as it is found,
 * without the update toast of the app. These pages are outside Layout, so without it a phone that has the
 * service worker (e.g. WhatsApp's in-app browser) would keep showing the cached old version.
 */
export function PwaAutoUpdate() {
  const {
    needRefresh: [needRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegisteredSW(_swUrl, registration) {
      if (!registration) return;
      setInterval(() => {
        if (navigator.onLine) void registration.update();
      }, UPDATE_CHECK_INTERVAL_MS);
    },
  });

  useEffect(() => {
    // Nothing to lose on a public page: activate the waiting version and reload.
    if (needRefresh) void updateServiceWorker(true);
  }, [needRefresh, updateServiceWorker]);

  return null;
}
